export default {"src":"/_next/static/media/reviews.f68df7ea.svg","height":329,"width":403,"blurWidth":0,"blurHeight":0};